import { styled } from "@mui/material/styles";
import {
  Box,
  Typography,
  Checkbox,
  List,
  ListItem,
} from "@mui/material";
import { TaskAltOutlined } from "@mui/icons-material";
import { colors } from "../../../theme/theme";

export const ContentBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
  paddingTop: 0,
  paddingBottom: 0,
}));

export const SectionTitle = styled(Typography)({
  fontFamily: "'Quicksand', sans-serif",
  fontSize: "14px",
  fontWeight: 500,
  color: colors.primary,
  marginBottom: 8,
  marginTop: 16,
  textTransform: "uppercase",
});

export const ItemWrapper = styled(Box)({
  display: "block",
});

export const StyledCheckboxIcon = styled(TaskAltOutlined)({
  color: colors.primary,
  opacity: 0.3,
});

export const StyledCheckboxCheckedIcon = styled(TaskAltOutlined)({
  color: colors.success,
});

export const StyledCheckbox = styled(Checkbox)({
  color: colors.primary,
  "&.Mui-checked": {
    color: colors.primary,
  },
});

export const LabelText = styled(Typography)({
  color: colors.primary,
  fontSize: "14px",
  fontWeight: 500,
  fontFamily: "'Quicksand', sans-serif",
});

export const StyledList = styled(List)(({ theme }) => ({
  paddingLeft: theme.spacing(4),
  paddingTop: 0,
  paddingBottom: 0,
}));

export const StyledListItem = styled(ListItem)(({ theme }) => ({
  display: "list-item",
  paddingLeft: 0,
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
}));

export const BulletText = styled(Typography)({
  fontSize: "14px",
  fontFamily: "'Quicksand', sans-serif",
  color: colors.primary,
  lineHeight: "20px",
});

export const SubList = styled(List)(({ theme }) => ({
  paddingLeft: theme.spacing(4),
  paddingTop: theme.spacing(2),
  paddingBottom: 0,
}));

export const SubListItem = styled(ListItem)({
  display: "list-item",
  paddingLeft: 0,
  paddingTop: 0,
});

export const SubBulletText = styled(Typography)({
  fontSize: "14px",
  fontFamily: "'Quicksand', sans-serif",
  color: colors.primary,
  lineHeight: "15px",
});
